/**
 * Запасной способ копирования через скрытое поле и команду браузера.
 * Текст кладется в буфер обработчиком события copy на window в фазе перехвата: он срабатывает раньше защиты
 * отчетов (ReportSecurityWrapper), которая гасит copy на document. Копирование кнопкой «Текст для WhatsApp»
 * разрешено отдельным правом и не должно считаться копированием выделенных данных; без обработчика
 * команда браузера возвращает успех, хотя защита ничего в буфер не записала.
 */
function copyViaTextarea(text: string): boolean {
  let copied = false;
  // Событие copy есть в типах document, но не window: тип события сужается внутри обработчика
  const handleCopy = (event: Event) => {
    const { clipboardData } = event as ClipboardEvent;
    if (!clipboardData) return;
    clipboardData.setData('text/plain', text);
    event.preventDefault();
    event.stopImmediatePropagation();
    copied = true;
  };

  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.left = '-9999px';
  area.style.top = '0';

  window.addEventListener('copy', handleCopy, true);
  document.body.appendChild(area);
  try {
    area.focus();
    area.select();
    return document.execCommand('copy') && copied;
  } finally {
    window.removeEventListener('copy', handleCopy, true);
    document.body.removeChild(area);
  }
}

/**
 * Копирует текст в буфер обмена. Clipboard API недоступен вне защищенного контекста (http)
 * и может быть запрещен политикой страницы, поэтому при отказе используется запасной способ.
 * Возвращает true, если текст попал в буфер.
 */
export async function copyText(text: string): Promise<boolean> {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Доступ к буферу запрещен - пробуем запасной способ
    }
  }
  return copyViaTextarea(text);
}
